var ptpt = {
	"coupon-callout": {
	"coupon-code": "Código",
	"coupon-message-with-price": "Basta {{ price }}",
	"coupon-expiry-message": "Expira {{ Date }}.",
	"code-at-checkout": "Introduza o código na finalização da compra. Não é acumulável com outros códigos promocionais, promoções ou descontos.",
	"cancel-icon": "Cancelar",
	"info-icon": "Ver detalhes",
	"check-icon": "Aplicado",
	"promo-code": "Código promocional",
	"coupon-callout-popover": "Popover de ação de cupão"
}
};

export { ptpt as default };
//# sourceMappingURL=src-localization-texts-pt-pt.json.js.map
